export const SubcontractPaymentRouting = [
  {
    path: "/subcontractManagement/payment/list",
    name: "subcontract-payment-list",
    meta: { title: "分包付款申请" },
    component: () => import("@/views/subcontract-management/subcontract-payment/list/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/payment/create",
    name: "subcontract-payment-create",
    meta: { title: "新增分包付款申请" , comName: "SubcontractManagementSubcontractPaymentFormCreate" },
    component: () => import("@/views/subcontract-management/subcontract-payment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/payment/edit/:id",
    name: "subcontract-payment-edit",
    meta: { title: "编辑分包付款申请" , comName: "SubcontractManagementSubcontractPaymentFormCreate" },
    component: () => import("@/views/subcontract-management/subcontract-payment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/payment/detail/:id",
    name: "subcontract-payment-detail",
    meta: { title: "分包付款申请详情" },
    component: () => import("@/views/subcontract-management/subcontract-payment/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/subcontractManagement/payment/flowPrint/:id",
    name: "subcontract-payment-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/subcontract-management/subcontract-payment/flow-print/index.vue"
      ),
  },
];
